export const upgradeResultCodes_t = {
  UPGRADE_STARTED: 6880,
  UPGRADE_COMPLETE: 6881,
  UPGRADE_ERROR: 6882,
};

export const upgradeStatusTable = [
  { value: 6880, label: 'Upgrade Started' },
  { value: 6881, label: 'Upgrade Complete' },
  { value: 6882, label: 'Upgrade Error' },
  { value: 6890, label: 'Upgrade 10%' },
  { value: 6900, label: 'Upgrade 20%' },
  { value: 6910, label: 'Upgrade 30%' },
  { value: 6920, label: 'Upgrade 40%' },
  { value: 6930, label: 'Upgrade 50%' },
  { value: 6940, label: 'Upgrade 60%' },
  { value: 6950, label: 'Upgrade 70%' },
  { value: 6960, label: 'Upgrade 80%' },
  { value: 6970, label: 'Upgrade 90%' },
  { value: 6980, label: 'Upgrade 100%' },
];

export const ota_error_code_e = {
  OTA_ERROR_CODE_NONE: 0,
  OTA_ERROR_CODE_TIMEOUT: 1,
  OTA_ERROR_CODE_COMMS_ERROR: 2,
  OTA_ERROR_CODE_REQUEST_INVALID: 3,
  OTA_ERROR_CODE_WIFI_CONFIG_INVALID: 4,
  OTA_ERROR_CODE_OTA_IMAGE_INVALID: 5,
  OTA_ERROR_CODE_OTA_CONNECT: 6,
  OTA_ERROR_CODE_OTA_TRANSFER: 7,
  OTA_ERROR_CODE_OTA_FINISH: 8,
};

export const ota_error_codeTable = [
  { value: 0, label: 'None' },
  { value: 1, label: 'Timeout' },
  { value: 2, label: 'Comms Error' },
  { value: 3, label: 'Request Invalid' },
  { value: 4, label: 'WiFi Config Invalid' },
  { value: 5, label: 'File Invalid' },
  { value: 6, label: 'Connection Error' },
  { value: 7, label: 'File Transfer Error' },
  { value: 8, label: 'Update Not Completed' },
];
